<div class="px-2 sm:px-4 md:px-6 py-4 max-w-6xl mx-auto">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">campaign</mat-icon>
      Mensajería Plataforma
      <span class="relative flex h-3 w-3 ml-2" *ngIf="socketConnected">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
      </span>
      <span class="relative flex h-3 w-3 ml-2" *ngIf="!socketConnected">
        <span class="relative inline-flex rounded-full h-3 w-3 bg-gray-400"></span>
      </span>
      <!-- Badge desktop -->
      <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
        {{ onlineRecipients.length }} conectados &middot; {{ filteredTotal }} total
      </span>
    </h1>
    <div class="flex gap-2">
      <button type="button" (click)="setMainTab('send')"
        [style.background]="mainTab === 'send' ? '#1C593D' : 'white'"
        [style.color]="mainTab === 'send' ? 'white' : '#374151'"
        [style.borderColor]="mainTab === 'send' ? '#1C593D' : '#d1d5db'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; border: 1px solid; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">edit</mat-icon>
        Redactar
      </button>
      <button type="button" (click)="setMainTab('history')"
        [style.background]="mainTab === 'history' ? '#1C593D' : 'white'"
        [style.color]="mainTab === 'history' ? 'white' : '#374151'"
        [style.borderColor]="mainTab === 'history' ? '#1C593D' : '#d1d5db'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; border: 1px solid; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">history</mat-icon>
        Historial
      </button>
    </div>
  </div>
  <!-- Badge mobile -->
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ onlineRecipients.length }} conectados &middot; {{ filteredTotal }} total
  </span>

  <!-- ==================== TAB: SEND ==================== -->
  <div *ngIf="mainTab === 'send'">

    <!-- Stat cards — audience selector -->
    <div class="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
      <button *ngFor="let tab of audienceTabs" type="button"
        class="stat-card"
        [class.stat-card--active]="audienceTab === tab.key"
        [ngClass]="'stat-card--' + tab.key"
        (click)="setAudienceTab(tab.key)">
        <mat-icon class="stat-card__icon">{{ tab.icon }}</mat-icon>
        <span class="stat-card__label">{{ tab.label }}</span>
      </button>
    </div>

    <!-- Filter indicator -->
    <div class="mb-4 flex items-center gap-2 flex-wrap">
      <span class="text-sm text-gray-500">Mostrando:</span>
      <span class="text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
        {{ filteredTotal }} {{ audienceLabel }}
      </span>
      <span *ngIf="selectedCount > 0" class="text-sm font-semibold px-3 py-1 rounded-full"
        style="background: #ecfdf5; color: #1C593D;">
        {{ selectedCount }} seleccionado(s)
      </span>
      <span *ngIf="selectedCount === 0" class="text-xs text-gray-400">
        Se enviará a todos los {{ audienceLabel }}
      </span>
    </div>

    <!-- 2-col layout -->
    <div class="grid grid-cols-1 lg:grid-cols-5 gap-4">

      <!-- LEFT: Recipients (3/5) -->
      <div class="lg:col-span-3">
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
          <!-- Gradient header -->
          <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 20px; border-bottom: 2px solid #bbf7d0;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">groups</mat-icon>
              <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Destinatarios</span>
            </div>
          </div>

          <!-- Search -->
          <div class="p-3" style="border-bottom: 1px solid #e5e7eb;">
            <div style="position: relative;">
              <mat-icon style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">search</mat-icon>
              <input type="text" placeholder="Buscar por nombre o email..."
                [value]="searchValue"
                (input)="onSearchInput($event)"
                style="width: 100%; padding: 9px 12px 9px 36px; border: 1px solid #d1d5db; border-radius: 10px; font-size: 0.82rem; outline: none; transition: border-color 0.2s;"
                onfocus="this.style.borderColor='#34d399'"
                onblur="this.style.borderColor='#d1d5db'">
            </div>
          </div>

          <!-- Quick actions -->
          <div class="flex items-center gap-2 px-3 py-2 flex-wrap" style="background: #fafafa; border-bottom: 1px solid #e5e7eb;">
            <button type="button" (click)="selectAllOnline()"
              style="padding: 4px 10px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; font-size: 0.72rem; font-weight: 600; color: #1C593D; cursor: pointer;">
              Conectados
            </button>
            <button type="button" (click)="selectAllVisible()"
              style="padding: 4px 10px; border: 1px solid #d1d5db; border-radius: 6px; background: white; font-size: 0.72rem; font-weight: 600; color: #374151; cursor: pointer;">
              Todos
            </button>
            <button type="button" (click)="deselectAll()"
              style="padding: 4px 10px; border: 1px solid #d1d5db; border-radius: 6px; background: white; font-size: 0.72rem; font-weight: 600; color: #6b7280; cursor: pointer;">
              Limpiar
            </button>
            <span *ngIf="selectedCount > 0" class="text-xs font-bold px-2 py-0.5 rounded-full ml-auto"
              style="background: #ecfdf5; color: #1C593D;">
              {{ selectedCount }}
            </span>
          </div>

          <!-- Loading -->
          <div *ngIf="loadingRecipients" class="text-center py-8">
            <mat-icon style="color: #9ca3af;">hourglass_empty</mat-icon>
            <p class="text-xs text-gray-400 mt-1">Cargando destinatarios...</p>
          </div>

          <!-- List -->
          <div *ngIf="!loadingRecipients" class="recipient-list">
            <!-- Online -->
            <div *ngIf="onlineRecipients.length > 0">
              <div class="recipient-section-header recipient-section-header--online">
                <span class="relative flex h-2 w-2">
                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                </span>
                Conectados ({{ onlineRecipients.length }})
              </div>
              <div *ngFor="let r of onlineRecipients" class="recipient-row"
                (click)="toggleRecipient(r)"
                [style.background]="isSelected(r) ? '#f0fdf4' : 'white'">
                <input type="checkbox" [checked]="isSelected(r)"
                  (change)="toggleRecipient(r)" (click)="$event.stopPropagation()"
                  style="accent-color: #1C593D; width: 15px; height: 15px; cursor: pointer; flex-shrink: 0;">
                <span class="relative flex h-2 w-2 shrink-0">
                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                </span>
                <span *ngIf="r.userId" class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0">{{ r.userId }}</span>
                <div class="flex-1 min-w-0">
                  <span class="text-xs font-semibold text-gray-800 truncate block">{{ r.nombre }} {{ r.apellidos }}</span>
                  <span style="font-size: 0.68rem; color: #9ca3af;">{{ r.email }}</span>
                </div>
                <span *ngIf="r.isOperator" class="recipient-badge recipient-badge--op">OP</span>
              </div>
            </div>

            <!-- Offline -->
            <div *ngIf="offlineRecipients.length > 0">
              <div class="recipient-section-header recipient-section-header--offline">
                <span class="flex h-2 w-2"><span class="inline-flex rounded-full h-2 w-2 bg-gray-300"></span></span>
                Desconectados ({{ offlineRecipients.length }})
              </div>
              <div *ngFor="let r of offlineRecipients" class="recipient-row"
                (click)="toggleRecipient(r)"
                [style.background]="isSelected(r) ? '#f0fdf4' : 'white'">
                <input type="checkbox" [checked]="isSelected(r)"
                  (change)="toggleRecipient(r)" (click)="$event.stopPropagation()"
                  style="accent-color: #1C593D; width: 15px; height: 15px; cursor: pointer; flex-shrink: 0;">
                <span class="flex h-2 w-2 shrink-0"><span class="inline-flex rounded-full h-2 w-2 bg-gray-300"></span></span>
                <span *ngIf="r.userId" class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0">{{ r.userId }}</span>
                <div class="flex-1 min-w-0">
                  <span class="text-xs font-semibold text-gray-800 truncate block">{{ r.nombre }} {{ r.apellidos }}</span>
                  <span style="font-size: 0.68rem; color: #9ca3af;">{{ r.email }}</span>
                </div>
                <span *ngIf="r.isOperator" class="recipient-badge recipient-badge--op">OP</span>
              </div>
            </div>

            <!-- Empty -->
            <div *ngIf="onlineRecipients.length === 0 && offlineRecipients.length === 0" class="text-center py-8">
              <mat-icon style="font-size: 32px; width: 32px; height: 32px; color: #d1d5db;">person_off</mat-icon>
              <p class="text-xs text-gray-400 mt-2">No se encontraron destinatarios</p>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT: Compose (2/5) -->
      <div class="lg:col-span-2">
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden lg:sticky lg:top-4">
          <!-- Gradient header -->
          <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 20px; border-bottom: 2px solid #bbf7d0;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">edit_note</mat-icon>
              <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Redactar mensaje</span>
            </div>
          </div>

          <form [formGroup]="form" (ngSubmit)="onSend()" class="p-4 space-y-3">
            <mat-form-field appearance="outline" class="modern-field modern-field--hint w-full">
              <mat-label>Asunto</mat-label>
              <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">subject</mat-icon>
              <input matInput formControlName="subject" maxlength="255" placeholder="Asunto del mensaje">
              <mat-hint align="end"
                [style.color]="(form.get('subject')?.value?.length || 0) > 230 ? '#f59e0b' : '#9ca3af'">
                {{ form.get('subject')?.value?.length || 0 }}/255
              </mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="modern-field modern-field--hint w-full">
              <mat-label>Mensaje</mat-label>
              <textarea matInput formControlName="body" rows="6" maxlength="5000" placeholder="Escribe el contenido del mensaje..."></textarea>
              <mat-hint align="end"
                [style.color]="(form.get('body')?.value?.length || 0) > 4500 ? '#f59e0b' : '#9ca3af'">
                {{ form.get('body')?.value?.length || 0 }}/5,000
              </mat-hint>
            </mat-form-field>

            <!-- Status + send -->
            <div style="background: #f9fafb; border-radius: 10px; padding: 12px; border: 1px solid #e5e7eb;">
              <div class="text-xs mb-3" style="color: #6b7280;">
                <span *ngIf="selectedCount > 0">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: -2px; color: #16a34a;">check_circle</mat-icon>
                  Se enviará a <strong style="color: #1C593D;">{{ selectedCount }}</strong> destinatario(s) seleccionado(s)
                </span>
                <span *ngIf="selectedCount === 0">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: -2px; color: #2563eb;">info</mat-icon>
                  Se enviará a <strong style="color: #1C593D;">todos los {{ audienceLabel }}</strong>
                </span>
              </div>
              <button type="submit"
                [disabled]="form.invalid"
                [style.opacity]="form.invalid ? '0.5' : '1'"
                [style.cursor]="form.invalid ? 'not-allowed' : 'pointer'"
                style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; width: 100%; justify-content: center;"
                onmouseover="this.style.background='#059669'"
                onmouseout="this.style.background='#1C593D'">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
                Enviar mensaje
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== TAB: HISTORY ==================== -->
  <div *ngIf="mainTab === 'history'">

    <!-- Filter tabs -->
    <div class="flex gap-1 mb-4 flex-wrap">
      <button *ngFor="let f of historyFilterTabs" type="button"
        (click)="setHistoryFilter(f.key)"
        [style.background]="historyFilter === f.key ? '#1C593D' : 'white'"
        [style.color]="historyFilter === f.key ? 'white' : '#374151'"
        [style.borderColor]="historyFilter === f.key ? '#1C593D' : '#e5e7eb'"
        style="display: inline-flex; align-items: center; gap: 5px; padding: 7px 14px; border: 1px solid; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;">
        {{ f.label }}
      </button>
    </div>

    <!-- Count -->
    <div class="mb-4 flex items-center gap-2">
      <span class="text-sm text-gray-500">Mostrando:</span>
      <span class="text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
        {{ sentMessages.length }} envíos
      </span>
    </div>

    <!-- Empty -->
    <div *ngIf="sentMessages.length === 0" class="text-center py-16">
      <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #d1d5db;">outbox</mat-icon>
      <p class="text-gray-400 mt-4 text-sm">No has enviado notificaciones</p>
    </div>

    <!-- History cards -->
    <div class="space-y-3">
      <div *ngFor="let msg of sentMessages"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedBatchId === msg.batchId ? '#1C593D' : '#e5e7eb'">

        <!-- Card header (siempre visible) -->
        <div class="card-header flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleHistoryCard(msg.batchId)"
          [style.background]="expandedBatchId === msg.batchId ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <div class="shrink-0 rounded-full"
              style="width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; background: #ecfdf5;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">mail</mat-icon>
            </div>
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="text-sm font-bold text-gray-800 truncate">{{ msg.subject }}</span>
                <span class="px-2 py-0.5 text-xs font-bold rounded-full shrink-0"
                  style="background: #f0fdf4; color: #1C593D;">
                  {{ getTargetLabel(msg.targetType) }}
                </span>
              </div>
              <div class="flex items-center gap-3 mt-0.5">
                <span class="text-xs text-gray-400">{{ formatDate(msg.createdAt) }}</span>
                <span class="text-xs font-semibold" style="color: #1e5a3f;">{{ msg.totalRecipients }} destinatarios</span>
              </div>
            </div>
          </div>
          <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
            [style.transform]="expandedBatchId === msg.batchId ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <!-- Card body (expandible) -->
        <div *ngIf="expandedBatchId === msg.batchId" class="card-details px-4 pb-4 border-t border-gray-100">

          <!-- Mensaje -->
          <div class="mt-3">
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Contenido</span>
            <div class="text-sm leading-relaxed whitespace-pre-wrap mt-1"
              style="background: #f9fafb; padding: 12px 16px; border-radius: 8px; color: #374151;">
              {{ msg.body }}
            </div>
          </div>

          <!-- Métricas -->
          <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4">
            <div style="background: #f0fdf4; border-radius: 12px; padding: 14px; text-align: center;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Destinatarios</span>
              <span style="font-size: 1.8rem; font-weight: 800; color: #1e5a3f;">{{ msg.totalRecipients }}</span>
            </div>
            <div style="background: #ecfdf5; border-radius: 12px; padding: 14px; text-align: center;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Online</span>
              <span style="font-size: 1.8rem; font-weight: 800; color: #16a34a;">{{ msg.deliveredOnlineCount }}</span>
            </div>
            <div style="background: #eff6ff; border-radius: 12px; padding: 14px; text-align: center;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Email</span>
              <span style="font-size: 1.8rem; font-weight: 800; color: #2563eb;">{{ msg.emailSentCount }}</span>
            </div>
            <div style="background: #fefce8; border-radius: 12px; padding: 14px; text-align: center;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Leídos</span>
              <span style="font-size: 1.8rem; font-weight: 800; color: #b45309;">{{ msg.readCount }}</span>
            </div>
          </div>

          <!-- Barras de progreso -->
          <div class="mt-4 space-y-3">
            <!-- Entrega -->
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-xs font-semibold" style="color: #374151;">Entrega</span>
                <span class="text-xs font-bold" style="color: #16a34a;">{{ getDeliveryPercent(msg) }}%</span>
              </div>
              <div style="background: #e5e7eb; border-radius: 6px; height: 6px; overflow: hidden;">
                <div style="background: #16a34a; height: 100%; border-radius: 6px; transition: width 0.3s ease;"
                  [style.width.%]="getDeliveryPercent(msg)"></div>
              </div>
            </div>
            <!-- Lectura -->
            <div>
              <div class="flex items-center justify-between mb-1">
                <span class="text-xs font-semibold" style="color: #374151;">Lectura</span>
                <span class="text-xs font-bold" style="color: #b45309;">{{ getReadPercent(msg) }}%</span>
              </div>
              <div style="background: #e5e7eb; border-radius: 6px; height: 6px; overflow: hidden;">
                <div style="background: #f59e0b; height: 100%; border-radius: 6px; transition: width 0.3s ease;"
                  [style.width.%]="getReadPercent(msg)"></div>
              </div>
            </div>
          </div>

          <!-- Desglose de entrega -->
          <div class="mt-4 pt-3 border-t border-gray-100">
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Desglose de entrega</span>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-2">
              <div class="flex items-center gap-2 text-xs" style="background: #f0fdf4; padding: 8px 12px; border-radius: 8px;">
                <span class="relative flex h-2 w-2 shrink-0">
                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                </span>
                <span style="color: #374151;">WebSocket (online)</span>
                <span class="ml-auto font-bold" style="color: #16a34a;">{{ msg.deliveredOnlineCount }}</span>
              </div>
              <div class="flex items-center gap-2 text-xs" style="background: #eff6ff; padding: 8px 12px; border-radius: 8px;">
                <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #2563eb;">email</mat-icon>
                <span style="color: #374151;">Email (offline)</span>
                <span class="ml-auto font-bold" style="color: #2563eb;">{{ msg.emailSentCount }}</span>
              </div>
              <div class="flex items-center gap-2 text-xs" style="background: #fefce8; padding: 8px 12px; border-radius: 8px;">
                <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #b45309;">visibility</mat-icon>
                <span style="color: #374151;">Leídos</span>
                <span class="ml-auto font-bold" style="color: #b45309;">{{ msg.readCount }} / {{ msg.totalRecipients }}</span>
              </div>
            </div>
          </div>

          <!-- Batch ID -->
          <div class="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.6rem;">Batch ID</span>
              <p class="font-mono text-xs mt-0.5" style="color: #9ca3af;">{{ msg.batchId }}</p>
            </div>
            <span class="px-2 py-0.5 text-xs font-bold rounded-full"
              style="background: #f0fdf4; color: #1C593D;">
              {{ getTargetLabel(msg.targetType) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="sentTotalPages > 1" class="flex items-center justify-center gap-4 mt-6">
      <button type="button"
        [disabled]="sentPage <= 1"
        (click)="onSentPageChange(-1)"
        [style.opacity]="sentPage <= 1 ? '0.4' : '1'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'"
        onmouseout="this.style.background='white'">
        Anterior
      </button>
      <span class="text-sm text-gray-500">Página {{ sentPage }} de {{ sentTotalPages }}</span>
      <button type="button"
        [disabled]="sentPage >= sentTotalPages"
        (click)="onSentPageChange(1)"
        [style.opacity]="sentPage >= sentTotalPages ? '0.4' : '1'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'"
        onmouseout="this.style.background='white'">
        Siguiente
      </button>
    </div>
  </div>
</div>
